const types = {
  UPDATE_HAS_UNREAD_MESSAGE: 'UPDATE_HAS_UNREAD_MESSAGE',
} as const

export default types
